<template>
  <div>
    <multiselect v-model="selectValue" :options="comboOptions" label="label" :searchable="true" :close-on-select="true" :show-labels="false" :placeholder="placeholder"></multiselect>
  </div>
</template>
<script>
export default {
  name: 'ComboBox',
  props: [ 'value', 'options', 'placeholder' ],
  computed: {
    comboOptions () {
        return this.options.map(o => ({ id: o.value, label: o.text }))
    }
  },
  data () {
    return {
      selectValue: null
    }
  },
  methods: {
    updateSelectValue () {
      const value = this.comboOptions.find(o => o.id === this.value)
      this.selectValue = value
    }
  },
  created () {
    this.updateSelectValue()
  },
  watch: {
    value: {
      handler () {
        this.updateSelectValue()
      }
    },
    options: {
      handler () {
        this.updateSelectValue()
      }
    },
    selectValue: {
        handler (value) {
          if (value) {
            this.$emit('update', value.id)
          }

        }
    }
  }
}
</script>

<style lang="scss">
.multiselect__single {
  font-size: 14px;
  color: rgb(92, 104, 115);
  line-height: 18px;
  min-height: 16px;
}

.multiselect__element {
  font-size: 14px;
  color: rgb(92, 104, 115);
}

.multiselect__input {
  font-size: 14px;
  color: rgb(92, 104, 115);
}

.multiselect__tags {
  min-height: 34px;
}

.multiselect__placeholder {
  min-height: 20px;
  margin-bottom: 6px;
  margin-top: 0px;
  line-height: 18px;
}

.multiselect__select {
  min-height: 36px;
}

</style>
